import { createFileRoute } from '@tanstack/react-router';

import Security from 'component/view/SiteDetails/Security';

import { requireOperation } from './-guards';
import { siteTabOperations } from './-site-tabs';

export const Route = createFileRoute('/n/_auth/sites/$siteId/_details/security')({
  beforeLoad: requireOperation({
    options: ({ params }) => siteTabOperations.security(params.siteId),
    siteId: ({ params }) => params.siteId,
  }),
  component: Security,
});
